import { render, staticRenderFns } from "./doctor-add.vue?vue&type=template&id=6bd4af14&scoped=true&"
import script from "./doctor-add.vue?vue&type=script&lang=js&"
export * from "./doctor-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4af14",
  null
  
)

export default component.exports